$(function () {

	// スクロールアニメーション
	new WOW().init();

	//ニュースティッカー
	// $.simpleTicker($(".top_news_main_wrap"),{'effectType':'roll'});

	var top_news_swiper = new Swiper('.top_news_swiper', {
		loop: true,
		autoHeight: true,
		// speed: 1500,
		autoplay: {
			delay: 4000,
		},
		spaceBetween: 30,
		// slidesPerView: 1.5,
		// centeredSlides: true,
		// pagination: {
		// 	el: '.swiper-pagination',
		// 	clickable: true,
		// },
	});

	//メインビジュアルフェード
	$('.top_mv').hide().fadeIn(1000);

	//フッターバナースライド(スマホのみ)
	var banner_swiper;
	$(window).on('load resize', function(){
		var w = $(window).width();
		if (w <= 768) {
			if (banner_swiper) {
				return;
			} else {
				banner_swiper = new Swiper('.banner_swiper', {
					loop: true,
					// speed: 1500,
					autoplay: {
						delay: 4000,
					},
					spaceBetween: 30,
					slidesPerView: 1.5,
					centeredSlides: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
				});
			}
		} else {
			if (banner_swiper) {
				banner_swiper.destroy();
				banner_swiper = undefined;
			}
		}
	});

});